// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_dj","imageUI":"e_ej","badgeContainer":"e_fj","badgeImage":"e_gj","container":"e_hj"};